"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputCreateBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_behavior_1 = require("../bc-input/bc-input-behavior");
var bc_input_create_constants_1 = require("./bc-input-create-constants");
var bc_input_create_dropdown_validations_1 = require("./bc-input-create-dropdown-validations");
var BcInputCreateBehavior = (function (_super) {
    __extends(BcInputCreateBehavior, _super);
    function BcInputCreateBehavior() {
        var _this = _super.call(this) || this;
        _this.conditionalItems = [];
        _this.returnValue = new Object();
        _this.toggleMask = true;
        _this.dropDown = new bc_input_create_dropdown_validations_1.BcInputCreateDropDownValidations();
        return _this;
    }
    BcInputCreateBehavior.setUpAll = function () {
        var inputCreateElements = Array.from(document.querySelectorAll(bc_input_create_constants_1.BcInputCreateConstants.DOCUMENT_QUERY));
        var elements = [];
        for (var _i = 0, inputCreateElements_1 = inputCreateElements; _i < inputCreateElements_1.length; _i++) {
            var inputCreateElement = inputCreateElements_1[_i];
            var element = inputCreateElement;
            var bcInputCreateBehavior = new BcInputCreateBehavior();
            bcInputCreateBehavior.setElement(element);
            bcInputCreateBehavior.setUp();
            elements.push(bcInputCreateBehavior);
        }
        return elements;
    };
    BcInputCreateBehavior.prototype._setUp = function () {
        this.typeAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR) || bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD;
        this.conditionalsAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.CONDITIONALS_ATR);
        this.maskAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.MASK_ATR);
        this.titleAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.TITLE_ATR);
        this.supportTextConditionAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR);
        this.titleIconAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.TITLE_ICON_ATR);
        this.statusAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.STATUS_ATR);
        if (this.maskAtr === bc_input_create_constants_1.BcInputCreateConstants.TRUE_VALUE) {
            this.maskAtr = true;
        }
        else {
            this.maskAtr = false;
        }
        if (this.statusAtr === bc_input_create_constants_1.BcInputCreateConstants.TRUE_VALUE) {
            this.statusAtr = true;
        }
        else {
            this.statusAtr = false;
        }
        this.getAttributesIcon();
        this.getIdsInputs();
        this.getAttributesLabel();
        this.getAttributesMsgError();
        this.createStructure(this.typeAtr, this.maskAtr);
        this.dropDown.createDropdownContainer(this.titleAtr, this.supportTextConditionAtr, this.titleIconAtr, this.mySelf);
        this.dropDown.initDropDownBehavior(this.mySelf);
        this.initInputBehavior();
        this.createReturn();
        this.listenners();
        this.dropDown.validateConditionals(this.mySelf, this.conditionalItems, this.conditionalsAtr, this.typeAtr, this.returnValue);
    };
    BcInputCreateBehavior.prototype.createReturn = function () {
        if (this.conditionalsAtr !== null && this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_USER) {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.USER_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = '';
        }
        if (this.conditionalsAtr !== null && this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD) {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.PASSWORD_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = '';
        }
        if (this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.NEW_PASSWORD_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = false;
        }
        if (this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.CURRENT_PASSWORD_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.NEW_PASSWORD_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.VALIDATIONS_VALUE] = '';
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = false;
        }
    };
    BcInputCreateBehavior.prototype.initInputBehavior = function () {
        var _this = this;
        var inputs = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
        inputs.forEach(function (input) {
            _this.inputBehavior = new bc_input_behavior_1.BcInputBehavior;
            _this.inputBehavior.setElement(input);
            _this.inputBehavior.setUp();
        });
    };
    BcInputCreateBehavior.prototype.getAttributesIcon = function () {
        this.firstIconAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.FIRST_ICON_ATR);
        this.secondIconAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SECOND_ICON_ATR);
        this.thirdIconAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.THIRD_ICON_ATR);
        this.titleIconAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.TITLE_ICON_ATR) || bc_input_create_constants_1.BcInputCreateConstants.ICON_LOCK;
    };
    BcInputCreateBehavior.prototype.getIdsInputs = function () {
        this.firstIdInputAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.FIRST_ID_INPUT_ATR) || bc_input_create_constants_1.BcInputCreateConstants.FIRST_ID_TEXT;
        this.secondIdInputAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SECOND_ID_INPUT_ATR) || bc_input_create_constants_1.BcInputCreateConstants.SECOND_ID_TEXT;
        this.thirdIdInputAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.THIRD_ID_INPUT_ATR) || bc_input_create_constants_1.BcInputCreateConstants.THIRD_ID_TEXT;
    };
    BcInputCreateBehavior.prototype.getAttributesLabel = function () {
        this.firstLabelAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.FIRST_LABEL_ATR) || bc_input_create_constants_1.BcInputCreateConstants.CURRENT_PASSWORD_VALUE_DEFAULT;
        this.secondLabelAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SECOND_LABEL_ATR) || bc_input_create_constants_1.BcInputCreateConstants.NEW_PASSWORD_VALUE_DEFAULT;
        this.thirdLabelAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.THIRD_LABEL_ATR) || bc_input_create_constants_1.BcInputCreateConstants.CONFIRM_PASSWORD_VALUE_DEFAULT;
        this.titleAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.TITLE_ATR) || bc_input_create_constants_1.BcInputCreateConstants.TITLE_VALUE_DEFAULT;
        this.supportTextConditionAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR) || bc_input_create_constants_1.BcInputCreateConstants.SUPPORT_TEXT_DEFAULT;
    };
    BcInputCreateBehavior.prototype.getAttributesMsgError = function () {
        this.firstMsgErrorAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.FIRST_MSG_ERROR_ATR) || bc_input_create_constants_1.BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT;
        this.secondMsgErrorAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.SECOND_MSG_ERROR_ATR) || bc_input_create_constants_1.BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT;
        this.thirdMsgErrorAtr = this.mySelf.getAttribute(bc_input_create_constants_1.BcInputCreateConstants.THIRD_MSG_ERROR_ATR) || bc_input_create_constants_1.BcInputCreateConstants.MSG_ERROR_VALIDATION_VALUE_DEFAULT;
    };
    BcInputCreateBehavior.prototype.listenners = function () {
        this.listenerClickInput();
        this.preventCopyCutPaste();
        this.listenerToggleMask();
        this.listenerFocusOut();
        this.listenerFocus();
        this.inputSpacingListener();
        this.validateEqualsInputs();
        this.listenerFocusOutEqual();
        this.listenerFocusEqual();
    };
    BcInputCreateBehavior.prototype.listenerFocus = function () {
        var _this = this;
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var span = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
        var inputEqual;
        var spanEqual;
        var emState;
        if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            inputEqual = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
            spanEqual = inputEqual.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            emState = inputEqual.parentElement.querySelectorAll(common_constants_1.BcCommonConstants.EM_TAG);
        }
        if (dropdownQuery) {
            var input_1 = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input_1.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
                var validators = _this.conditionalItems;
                var inputValue = input_1.value;
                _this.dropDown.dropDownBehavior.openDrowndown();
                if (inputValue.length === 0) {
                    validators.forEach(function (item) {
                        _this.dropDown.changeStatusItemDot(item.condition, _this.mySelf);
                    });
                }
                input_1.classList.remove(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                input_1.classList.remove(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR);
                span.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
                if (inputEqual !== undefined) {
                    inputEqual.classList.remove(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                }
                if (_this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
                    emState[1].textContent = '';
                    spanEqual.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
                }
            });
        }
    };
    BcInputCreateBehavior.prototype.listenerFocusOut = function () {
        var _this = this;
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var span = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
        var inputEqual = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
        var inputEqualSpan;
        var emState;
        if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            emState = inputEqual.parentElement.querySelectorAll(common_constants_1.BcCommonConstants.EM_TAG);
            inputEqualSpan = inputEqual.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
        }
        if (dropdownQuery) {
            var input_2 = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input_2.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function () {
                var validators = _this.dropDown.getValidations(_this.conditionalItems);
                var filterItems = _this.dropDown.getFilterValidations(_this.conditionalItems);
                _this.focusOutValidations(validators, filterItems, input_2, inputEqual, span, inputEqualSpan, emState);
            });
        }
    };
    BcInputCreateBehavior.prototype.focusOutValidations = function (validators, filterItems, fstValue, sndInput, fstSpan, sndSpan, emState) {
        var _this = this;
        var inputValue = fstValue.value;
        if (validators) {
            fstValue.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS);
        }
        else {
            fstValue.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR);
            fstSpan.style.visibility = bc_input_create_constants_1.BcInputCreateConstants.VISIBLE_VALUE;
        }
        if (inputValue.length !== 0) {
            filterItems.forEach(function (item) {
                _this.dropDown.changeStatusItem(item.condition, _this.mySelf);
            });
        }
        if (inputValue.length === 0) {
            fstValue.classList.remove(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR);
            fstValue.classList.remove(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS);
            fstValue.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT);
            fstSpan.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
        }
        this.focusOutTypeValidations(inputValue, this.returnInputValueEqual(sndInput), sndInput, sndSpan, emState);
    };
    BcInputCreateBehavior.prototype.returnInputValueEqual = function (sndInput) {
        if (sndInput) {
            return sndInput.value;
        }
    };
    BcInputCreateBehavior.prototype.focusOutTypeValidations = function (fstValue, sndValue, sndInput, sndSpan, emState) {
        if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            if (fstValue === sndValue && fstValue.length !== 0) {
                sndInput.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                emState[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_SUCCESSFUL;
                this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = true;
            }
            if (fstValue.length === 0 && sndValue.length !== 0) {
                sndInput.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR);
                emState[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_REMOVE;
                sndSpan.style.visibility = bc_input_create_constants_1.BcInputCreateConstants.VISIBLE_VALUE;
            }
            if (fstValue !== sndValue && sndValue.length !== 0) {
                sndInput.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR);
                emState[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_REMOVE;
                sndSpan.style.visibility = bc_input_create_constants_1.BcInputCreateConstants.VISIBLE_VALUE;
            }
        }
    };
    BcInputCreateBehavior.prototype.listenerFocusEqual = function () {
        var _this = this;
        if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            var input = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
            var span_1 = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            var emState_1 = input.parentElement.querySelectorAll(common_constants_1.BcCommonConstants.EM_TAG);
            if (input) {
                input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
                    _this.dropDown.dropDownBehavior.closeDropdown();
                    emState_1[1].textContent = '';
                    span_1.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
                });
            }
        }
    };
    BcInputCreateBehavior.prototype.listenerFocusOutEqual = function () {
        var _this = this;
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var inputValidator = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        var input = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
        var span;
        var emState;
        if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            emState = input.parentElement.querySelectorAll(common_constants_1.BcCommonConstants.EM_TAG);
            emState[1].classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        }
        if (input) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function () {
                _this.focusOutEqualValidations(input, inputValidator, span, emState);
            });
        }
    };
    BcInputCreateBehavior.prototype.focusOutEqualValidations = function (fstInput, sndInput, span, emState) {
        var inputValue = fstInput.value;
        var inputValitadorValue = sndInput.value;
        if (inputValue === inputValitadorValue && inputValitadorValue.length !== 0 && inputValue.length !== 0) {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = true;
            emState[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_SUCCESSFUL;
        }
        else {
            this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = false;
            fstInput.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR));
            if (this.validateTypes([bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
                span.style.visibility = bc_input_create_constants_1.BcInputCreateConstants.VISIBLE_VALUE;
                emState[1].textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_REMOVE;
            }
        }
        if (inputValue.length === 0) {
            fstInput.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR));
            fstInput.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT));
            span.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
            emState[1].textContent = '';
        }
        if (inputValitadorValue.length === 0 && inputValue.length === 0) {
            fstInput.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS));
            fstInput.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR));
            fstInput.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT));
            span.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
            emState[1].textContent = '';
        }
    };
    BcInputCreateBehavior.prototype.validateTypes = function (types) {
        return types.includes(this.typeAtr);
    };
    BcInputCreateBehavior.prototype.validateEqualsInputs = function () {
        var _this = this;
        var input = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var inputDropdown = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        if (input) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
                var value = input.value;
                input.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_ERROR));
                if (value === inputDropdown.value) {
                    input.classList.add("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS));
                    _this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = true;
                }
                else {
                    input.classList.remove("".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_SUCCESS));
                    _this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.EQUAL_VALUE] = false;
                }
            });
        }
    };
    BcInputCreateBehavior.prototype.listenerToggleMask = function () {
        var input;
        var buttonState = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_BUTTON_ICON));
        if (this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_USER || this.typeAtr === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD) {
            input = this.mySelf.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        }
        else {
            var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
            input = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        }
        if (buttonState) {
            this.toggleWithClick(buttonState, input);
            this.toggleWithKeyboard(buttonState, input);
        }
    };
    BcInputCreateBehavior.prototype.toggleWithClick = function (btn, input) {
        var _this = this;
        btn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.toggleMask = !_this.toggleMask;
            if (!_this.toggleMask) {
                input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_TEXT);
                btn.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_VIEW;
            }
            if (_this.toggleMask) {
                input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD);
                btn.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_NO_VIEW;
            }
        });
    };
    BcInputCreateBehavior.prototype.toggleWithKeyboard = function (btn, input) {
        var _this = this;
        btn.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            var _event = event;
            if (_event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || _event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                _this.toggleMask = !_this.toggleMask;
                if (!_this.toggleMask) {
                    input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_TEXT);
                    btn.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_VIEW;
                }
                if (_this.toggleMask) {
                    input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD);
                    btn.textContent = bc_input_create_constants_1.BcInputCreateConstants.ICON_NO_VIEW;
                }
            }
        });
    };
    BcInputCreateBehavior.prototype.listenerClickInput = function () {
        var _this = this;
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        if (dropdownQuery !== null) {
            var input = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                event.stopPropagation();
                event.preventDefault();
                _this.dropDown.dropDownBehavior.openDrowndown();
            });
        }
    };
    BcInputCreateBehavior.prototype.inputSpacingListener = function () {
        var fstInput = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT));
        var dropdownQuery = this.mySelf.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS));
        var sndInput = dropdownQuery.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        var trdInput = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL));
        if (fstInput) {
            this.preventSpacing(fstInput);
        }
        if (sndInput) {
            this.preventSpacing(sndInput);
        }
        if (trdInput) {
            this.preventSpacing(trdInput);
        }
    };
    BcInputCreateBehavior.prototype.preventSpacing = function (input) {
        var _this = this;
        var fstInput = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT));
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            var value = input.value;
            if (value.includes(' ')) {
                var arrText = Array.from(value);
                arrText.pop();
                var text = arrText.toString();
                var textNonArray = text.replace(/,/g, '');
                input.value = textNonArray;
            }
            if (input === fstInput) {
                _this.returnValue[bc_input_create_constants_1.BcInputCreateConstants.CURRENT_PASSWORD_VALUE] = value;
            }
        });
    };
    BcInputCreateBehavior.prototype.preventCopyCutPaste = function () {
        var container = this.mySelf.querySelector(".".concat(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER));
        var inputs = container.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
        inputs.forEach(function (char) {
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_PASTE, function (event) {
                event.preventDefault();
            });
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_COPY, function (event) {
                event.preventDefault();
            });
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_CUT, function (event) {
                event.preventDefault();
            });
        });
    };
    BcInputCreateBehavior.prototype.createStructure = function (type, mask) {
        var idComponent = this.mySelf.getAttribute(common_constants_1.BcCommonConstants.ID);
        var element = document.getElementById(idComponent);
        var section = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        section.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER);
        element === null || element === void 0 ? void 0 : element.appendChild(section);
        var mainContainer = section;
        this.createTypeUser(type, mask, mainContainer);
        this.createTypePassword(type, mask, mainContainer);
        this.createTypePasswordCreate(type, mask, mainContainer);
        this.createTypePasswordUpdate(type, mask, mainContainer);
    };
    BcInputCreateBehavior.prototype.createTypeUser = function (type, mask, mainContainer) {
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_USER) {
            var firstContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.firstLabelAtr));
            var dropDownBoolean = this.conditionalsAtr === null ? false : true;
            this.createInput(firstContainer, { icon: this.firstIconAtr, id: this.firstIdInputAtr, textLabel: this.firstLabelAtr, errorMsg: this.firstMsgErrorAtr,
                dropDown: dropDownBoolean, mask: false, type: type });
            mainContainer.appendChild(firstContainer);
        }
    };
    BcInputCreateBehavior.prototype.createTypePassword = function (type, mask, mainContainer) {
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD) {
            var firstContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.firstLabelAtr, ", editar texto seguro."));
            var dropDownBoolean = this.conditionalsAtr === null ? false : true;
            this.createInput(firstContainer, { icon: this.firstIconAtr, id: this.firstIdInputAtr, textLabel: this.firstLabelAtr, errorMsg: this.firstMsgErrorAtr,
                dropDown: dropDownBoolean, mask: mask, type: type });
            mainContainer.appendChild(firstContainer);
        }
    };
    BcInputCreateBehavior.prototype.createTypePasswordCreate = function (type, mask, mainContainer) {
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            var firstContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.firstLabelAtr, ", editar texto seguro."));
            this.createInput(firstContainer, { icon: this.firstIconAtr, id: this.firstIdInputAtr, textLabel: this.firstLabelAtr, errorMsg: this.firstMsgErrorAtr,
                dropDown: true, mask: mask });
            var secondContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_SECOND_CONTAINER);
            secondContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.secondLabelAtr, ", editar texto seguro."));
            this.createInput(secondContainer, { icon: this.secondIconAtr, id: this.secondIdInputAtr, textLabel: this.secondLabelAtr, errorMsg: this.secondMsgErrorAtr,
                dropDown: false, mask: false, type: '', aditionalClass: bc_input_create_constants_1.BcInputCreateConstants.EQUAL_TEXT });
            mainContainer.appendChild(firstContainer);
            mainContainer.appendChild(secondContainer);
        }
    };
    BcInputCreateBehavior.prototype.createTypePasswordUpdate = function (type, mask, mainContainer) {
        var _this = this;
        if (type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            var firstContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.firstLabelAtr, ", editar texto seguro."));
            this.createInput(firstContainer, { icon: this.firstIconAtr, id: this.firstIdInputAtr, textLabel: this.firstLabelAtr, errorMsg: this.firstMsgErrorAtr,
                dropDown: false, mask: false, type: '', aditionalClass: bc_input_create_constants_1.BcInputCreateConstants.FIRST_TEXT });
            var secondContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_SECOND_CONTAINER);
            secondContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.secondLabelAtr, ", editar texto seguro."));
            this.createInput(secondContainer, { icon: this.secondIconAtr, id: this.secondIdInputAtr, textLabel: this.secondLabelAtr, errorMsg: this.secondMsgErrorAtr,
                dropDown: true, mask: mask });
            var thirdContainer = this.dropDown.createContainner(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, bc_input_create_constants_1.BcInputCreateConstants.CLASS_THIRD_CONTAINER);
            thirdContainer.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(this.thirdLabelAtr, ", editar texto seguro."));
            this.createInput(thirdContainer, { icon: this.thirdIconAtr, id: this.thirdIdInputAtr, textLabel: this.thirdLabelAtr, errorMsg: this.thirdMsgErrorAtr,
                dropDown: false, mask: false, type: '', aditionalClass: bc_input_create_constants_1.BcInputCreateConstants.EQUAL_TEXT });
            mainContainer.appendChild(firstContainer);
            mainContainer.appendChild(secondContainer);
            mainContainer.appendChild(thirdContainer);
            thirdContainer.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
                _this.dropDown.dropDownBehavior.closeDropdown();
            });
        }
    };
    BcInputCreateBehavior.prototype.createInput = function (container, config) {
        var _a = this.createStylesInput(config.id, config.type, config.mask, config.textLabel, config.errorMsg), emIcon = _a.emIcon, formField = _a.formField, input = _a.input, emMaskState = _a.emMaskState, label = _a.label, span = _a.span, spanHidden = _a.spanHidden;
        if (config.icon) {
            emIcon.innerText = config.icon;
            formField.appendChild(emIcon);
        }
        formField.appendChild(input);
        formField.appendChild(emMaskState);
        formField.appendChild(label);
        formField.appendChild(span);
        formField.appendChild(spanHidden);
        if (config.aditionalClass === bc_input_create_constants_1.BcInputCreateConstants.EQUAL_TEXT) {
            input.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL);
        }
        if (config.aditionalClass === bc_input_create_constants_1.BcInputCreateConstants.FIRST_TEXT) {
            input.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT);
        }
        this.conditionalDropDown(config.dropDown, container, config.id, spanHidden, formField);
        container.appendChild(formField);
        this.accesibility(emMaskState, span, label, config.textLabel, input, emIcon);
        if (this.statusAtr) {
            input.setAttribute(common_constants_1.BcCommonConstants.DISABLED, 'true');
            formField.setAttribute(common_constants_1.BcCommonConstants.DISABLED, 'true');
            container.setAttribute(common_constants_1.BcCommonConstants.DISABLED, 'true');
        }
    };
    BcInputCreateBehavior.prototype.createStylesInput = function (id, type, mask, textLabel, errorMsg) {
        var formField = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        var emIcon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        var input = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        var emMaskState = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        var label = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        var span = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        var spanHidden = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        formField.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_FORM_FIELD);
        input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.ID_ATR, id);
        type === bc_input_create_constants_1.BcInputCreateConstants.TYPE_USER ?
            input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_TEXT) :
            input.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.TYPE_ATR, bc_input_create_constants_1.BcInputCreateConstants.TYPE_PASSWORD);
        label.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.FOR_ATR, id);
        input.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_INPUT);
        spanHidden.style.display = bc_input_create_constants_1.BcInputCreateConstants.NONE_TEXT;
        this.conditionalMask(mask, emMaskState);
        label.innerText = textLabel;
        span.innerText = errorMsg;
        span.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
        return { emIcon: emIcon, formField: formField, input: input, emMaskState: emMaskState, label: label, span: span, spanHidden: spanHidden };
    };
    BcInputCreateBehavior.prototype.accesibility = function (emMaskState, span, label, textLabel, input, emIcon) {
        (0, helpers_1.addFocusable)(emMaskState, { tabindex: "0" });
        (0, helpers_1.addFocusable)(span, { tabindex: "0" });
        label.setAttribute('aria-hidden', 'true');
        label.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(textLabel));
        input.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "".concat(textLabel, ", editar texto seguro"));
        emIcon.setAttribute('aria-hidden', 'true');
    };
    BcInputCreateBehavior.prototype.conditionalDropDown = function (dropDown, container, id, spanHidden, formField) {
        if (dropDown) {
            if (this.conditionalsAtr !== '') {
                var mainContainerDropdown = this.dropDown.createContainner(container.className, bc_input_create_constants_1.BcInputCreateConstants.CLASS_DROPDOWN_CONTENT);
                var section = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
                section.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS);
                mainContainerDropdown.appendChild(section);
                mainContainerDropdown.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.ID_ATR, "".concat(bc_input_create_constants_1.BcInputCreateConstants.MY_DROPDOWN_TEXT, "-").concat(id));
                spanHidden.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_DROPDOWN_TOGGLE);
                spanHidden.setAttribute(bc_input_create_constants_1.BcInputCreateConstants.ARIA_CONTROLS_ATR, "".concat(bc_input_create_constants_1.BcInputCreateConstants.MY_DROPDOWN_TEXT, "-").concat(id));
                container.classList.add(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS);
                formField.appendChild(mainContainerDropdown);
            }
        }
    };
    BcInputCreateBehavior.prototype.conditionalMask = function (mask, emMaskState) {
        if (mask) {
            emMaskState.classList.add(bc_input_create_constants_1.BcInputCreateConstants.CLASS_BUTTON_ICON);
            emMaskState.innerText = bc_input_create_constants_1.BcInputCreateConstants.ICON_NO_VIEW;
            emMaskState.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'Mostrar/Ocultar contraseña, botón');
        }
    };
    return BcInputCreateBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputCreateBehavior = BcInputCreateBehavior;
